/**
 * External Dependencies
 */
import 'jquery';
import 'slick-carousel';

import Nav from './nav';
import Header from './header';
import FaqCard from './faq-card';
import ScrollTo from './scroll-to';
import Cookiebar from './cookiebar';
import SlickCarousel from './slick-carousel';

$(() => {
  // console.log('app.js');
  new Nav().init();
  new Header().init();
  new FaqCard().init();
  new ScrollTo().init();
  new Cookiebar().init();
  new SlickCarousel().init();

  //
  //
  // DEV
  //
  //

  // console.log('Hello world');
  const basefontsize = document.querySelector('#basefontsize');
  const heightOutput = document.querySelector('#height');
  const widthOutput = document.querySelector('#width');

  function reportWindowSize() {
    const basefont = (window.innerWidth / 100) * 1.125;

    if (window.innerWidth > 1920) {
      basefontsize.textContent = '22.00'
    } else if (basefont < 14) {
      basefontsize.textContent = '14.00'
    } else {
      basefontsize.textContent = basefont.toFixed(2);
    }

    heightOutput.textContent = window.innerHeight;
    widthOutput.textContent = window.innerWidth;
  }

  if (basefontsize && heightOutput && widthOutput) {
    window.onresize = reportWindowSize;
    window.onload = reportWindowSize;
  }
});
